import { useState } from 'react';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    mensaje: '',
    acceptTerms: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.acceptTerms) {
      setSubmitStatus('Debe aceptar los términos y condiciones');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value.toString());
      });

      const response = await fetch('https://readdy.ai/api/form/d4cdppqahcjh6clrr7sg', {
        method: 'POST',
        body: formDataToSend
      });

      if (response.ok) {
        setSubmitStatus('¡Mensaje enviado con éxito! Nos pondremos en contacto contigo pronto.');
        setFormData({
          nombre: '',
          email: '',
          telefono: '',
          mensaje: '',
          acceptTerms: false
        });
      } else {
        setSubmitStatus('Error al enviar el mensaje. Por favor, inténtelo de nuevo.');
      }
    } catch (error) {
      setSubmitStatus('Error al enviar el mensaje. Por favor, inténtelo de nuevo.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bg-white p-8 lg:p-12 rounded-sm shadow-lg animate-slide-up">
      <h2 className="text-3xl museo-font text-[#3a3a3a] mb-8 font-medium">
        Envíanos un mensaje
      </h2>

      <form onSubmit={handleSubmit} className="space-y-6" data-readdy-form id="contacto-altta">
        <div>
          <label className="block text-sm font-medium text-[#3a3a3a] mb-2">
            Nombre completo *
          </label>
          <input
            type="text"
            name="nombre"
            value={formData.nombre}
            onChange={handleInputChange}
            required
            className="w-full px-4 py-3 border border-gray-200 rounded focus:ring-2 focus:ring-[#ffb7b4] focus:border-transparent outline-none text-sm"
            placeholder="Su nombre completo"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-[#3a3a3a] mb-2">
            Email *
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            required
            className="w-full px-4 py-3 border border-gray-200 rounded focus:ring-2 focus:ring-[#ffb7b4] focus:border-transparent outline-none text-sm"
            placeholder="su@email.com"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-[#3a3a3a] mb-2">
            Teléfono
          </label>
          <input
            type="tel"
            name="telefono"
            value={formData.telefono}
            onChange={handleInputChange}
            className="w-full px-4 py-3 border border-gray-200 rounded focus:ring-2 focus:ring-[#ffb7b4] focus:border-transparent outline-none text-sm"
            placeholder="+34 XXX XXX XXX"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-[#3a3a3a] mb-2">
            Mensaje *
          </label>
          <textarea
            name="mensaje"
            value={formData.mensaje}
            onChange={handleInputChange}
            required
            rows={6}
            maxLength={500}
            className="w-full px-4 py-3 border border-gray-200 rounded focus:ring-2 focus:ring-[#ffb7b4] focus:border-transparent outline-none text-sm resize-none"
            placeholder="Cuéntanos sobre tu proyecto, evento o cualquier consulta que tengas..."
          />
          <p className="text-xs text-gray-500 mt-1">{formData.mensaje.length}/500 caracteres</p>
        </div>

        <div className="flex items-start">
          <input
            type="checkbox"
            name="acceptTerms"
            checked={formData.acceptTerms}
            onChange={handleInputChange}
            required
            className="mt-1 mr-3"
          />
          <label className="text-sm text-[#3a3a3a]/80">
            Acepto los términos y condiciones y autorizo el tratamiento de mis datos personales 
            conforme a la política de privacidad. *
          </label>
        </div>

        {submitStatus && (
          <div className={`p-4 rounded text-sm ${
            submitStatus.includes('éxito') 
              ? 'bg-green-50 text-green-700 border border-green-200' 
              : 'bg-red-50 text-red-700 border border-red-200'
          }`}>
            {submitStatus}
          </div>
        )}

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full btn-primary text-center disabled:opacity-50"
        >
          {isSubmitting ? 'Enviando...' : 'Enviar Mensaje'}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;